var map = {
	"./img_1.jpg": 38943,
	"./img_10.jpg": 79153,
	"./img_2.jpg": 34130,
	"./img_3.jpg": 59948,
	"./img_4.jpg": 773,
	"./img_5.jpg": 17979,
	"./img_6.jpg": 2825,
	"./img_7.jpg": 51101,
	"./img_8.jpg": 42792,
	"./img_9.jpg": 39719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20579;